import { useLocation, useNavigate } from "react-router-dom";
import AsyncSelect from "react-select/async";
import { useState, useRef, useEffect } from "react";
import axios from "axios";

import { DropdownIndicator } from "../../../components/header/headerTop/headerSelects/selects";
import { customStyles2 } from "../../../components/header/headerTop/headerSelects/selects";
import { ArrowLeftIcon } from "../../../components/icons/ArrowLeftIcon";
import getHost, { link } from "../../../store/host-store";
import { token } from "../../../App";
import s from "./style.module.sass";
import Editor from "../../../UI/Editors/Editor";

const FaqEditQuestion = () => {
    const [options, setOptions] = useState([]);
    const [success, setSuccess] = useState(false);
    const [isDeleted, setIsDeleted] = useState(false);
    const editorRefQuestion = useRef(null);
    const editorRefAnswer = useRef(null);
    const [questionAPI, setQuestionAPI] = useState("");
    const [answerAPI, setAnswerAPI] = useState("");

    const history = useNavigate();
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);

        fetch(
            getHost({
                controller: "faq-section",
                action: location.state.section_id,
            }),
            {
                headers: {
                    Accept: "application/json",
                    Authorization: token,
                },
            }
        )
            .then((res) => res.json())
            .then((result) => {
                if (result.success) {
                    setOptions({
                        value: result.data.id,
                        label: result.data.title,
                    });
                }
            })
            .catch((e) => console.log(e));

        fetch(
            getHost({
                controller: "faq-element",
                action: location.state.id,
            }),
            {
                headers: {
                    Accept: "application/json",
                    Authorization: token,
                },
            }
        )
            .then((res) => res.json())
            .then((result) => {
                if (result.success) {
                    setQuestionAPI(result.data.question);
                    setAnswerAPI(result.data.answer);
                }
            })
            .catch((e) => console.log(e));
    }, [location.state.id, location.state.section_id]);

    const loadOptions = (inputValue, callback) => {
        let options = [];
        axios
            .create({
                baseURL: `${link}`,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            })
            .get(`faq-section?filter[type_id]=${location.state.section_id}`)
            .then((response) => {
                response.data.data.forEach((permission) => {
                    options.push({
                        label: permission.title,
                        value: permission.id,
                    });
                    callback(options.filter((i) => i.label.toLowerCase().includes(inputValue.toLowerCase())));
                });
            });
    };

    const submitHandler = (e) => {
        e.preventDefault();

        const formData = new FormData();

        if (editorRefQuestion.current) {
            formData.append("question", editorRefQuestion.current);
        }
        if (editorRefAnswer.current) {
            formData.append("answer", editorRefAnswer.current);
        }

        formData.append("section_id", options.value);
        formData.append("active", 1);

        axios
            .put(
                getHost({
                    controller: "faq-element",
                    action: location.state.id,
                }),
                formData,
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: token,
                    },
                }
            )
            .then((result) => {
                if (result.data.success) {
                    setSuccess(true);
                }
            });
    };

    const remove = () => {
        axios
            .delete(
                getHost({
                    controller: "faq-element",
                    action: location.state.id,
                }),
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: token,
                    },
                }
            ).then(res => {
            if (res.data.success) {
                setIsDeleted(true);
                history(-1)
            }
        })
    }

    return (
        <div className="admin__layout">
            <form className={s.create}>
                <div className={s.top_wrapper}>
                    <div className={s.title}>
                        <div className="admin__back-arrow" onClick={() => history(-1)}>
                            <ArrowLeftIcon />
                        </div>
                        <h3>Редактировать вопрос</h3>
                    </div>
                    <div>
                        <div>
                            <button type="button" className="admin__btn-blue" onClick={submitHandler}>
                                Сохранить
                            </button>
                            {success && (
                                <div className={s.success}>
                                    <span className="admin__success">Изменения сохранены</span>
                                </div>
                            )}
                        </div>
                        <button type="button" className={s.btn_red} onClick={remove}>Удалить</button>
                        {isDeleted && (
                            <div>
                                <span className={s.deleted_span}>Удалено</span>
                            </div>
                        )}
                    </div>
                </div>

                <div className={s.bottom_wrapper}>
                    <AsyncSelect
                        key={options}
                        components={{ DropdownIndicator }}
                        placeholder={"Секция"}
                        cacheOptions
                        defaultOptions
                        onChange={setOptions}
                        value={options}
                        styles={customStyles2}
                        loadOptions={loadOptions}
                    />
                </div>
                <div className={s.question}>
                    <h3>Вопрос</h3>
                    <Editor editorRef={editorRefQuestion} textFromAPI={questionAPI} />
                </div>
                <div>
                    <h3>Ответ</h3>
                    <Editor editorRef={editorRefAnswer} textFromAPI={answerAPI} />
                </div>
            </form>
        </div>
    );
};

export default FaqEditQuestion;
